//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'material-icons/iconfont/material-icons.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@nuxeo/nuxeo-elements/nuxeo-connection.js';
import Vue from 'vue';
import {insightService} from './insight-service'
import Vuelidate from 'vuelidate';
import VueMaterial from 'vue-material';
import {mapGetters, mapMutations} from 'vuex';
import CookieLaw from 'vue-cookie-law';
import * as FullStory from '@fullstory/browser';
import VueGtag from 'vue-gtag';
import CollapsePlugin from 'bootstrap-vue';

Vue.use(Vuelidate);
Vue.use(VueMaterial);
Vue.use(CollapsePlugin)

export default {
  name: "app",

  data: () => ({
    menuVisible: false,
    hover: false,
    closeOnClick: true,
    datasource: 'OFF',
  }),

  components: {CookieLaw},

  mounted() {
    this.$refs.aiCloud.connect().then((user) => {
      // Setup insight UI
      this.initializeInsightUI(user);
      // Setup FullStory and GA
      if (process.env.NODE_ENV === 'production') {
        Vue.use(VueGtag, {
          config: {id: 'UA-81135-33'}
        });
        FullStory.init({orgId: 'V75R7'});
        Vue.prototype.$FullStory = FullStory;
        FullStory.identify('0', {
          displayName: user.properties.company,
        });
      }
    }).catch(() => {
      this.setCurrentClient({});
      this.navigateToNotFound();
    });
  },

  computed: {
    isDashboard: function () {
      return this.$route.name === 'dashboard';
    },
    isMetrics: function () {
      return this.$route.name === 'metrics';
    },
    isMissions: function () {
      return this.$route.name === 'missions';
    },
    isWizard: function () {
      return this.$route.name === 'wizard';
    },
    isConfig: function () {
      return this.$route.name === 'config';
    },
    hasNoCoreConnection: function () {
      return !this.datasource || !this.isConnected(this.datasource);
    },
    url: function () {
      const CLOUD_URL = process.env.VUE_APP_AI_CLOUD_URL;
      const origin = window.location.origin;
      return CLOUD_URL ? CLOUD_URL : `${origin}/nuxeo`;
    },
    urlCore: function () {
      // Checking first the query param, then the local storage and otherwise return default env url.
      const url = this.$route.query.urlCore;
      if (url) {
        this.setUrlCore(url);
        window.localStorage.setItem("ai-url", url);
        return url;
      }

      let urlCore = window.localStorage.getItem("ai-url");
      urlCore = urlCore ? urlCore : process.env.VUE_APP_AI_CORE_URL;
      this.setUrlCore(urlCore);

      return urlCore;
    },
    token: function () {
      // Checking first the query param, then the local storage and otherwise return default env token.
      const token = this.$route.query.aitoken;
      if (token) {
        window.localStorage.setItem("ai-token", token);
        return token;
      }
      const localToken = window.localStorage.getItem("ai-token");
      return localToken ? localToken : process.env.VUE_APP_AI_CLOUD_TOKEN;
    },
    ...mapGetters(["snackSuccess", "snackError", "AIResourcePath", "currentClient"]),
    initial: function () {
      if (this.currentClient && Object.keys(this.currentClient).length !== 0) {
        return this.currentClient.properties.username.charAt(0);
      }
      return "@";
    },
  },
  methods: {
    initializeInsightUI(user) {
      // Checking first the query param, then the local storage and otherwise return default env projectid.
      const projectId = this.$route.query.projectid || window.localStorage.getItem("ai-projectid");
      const localProjectId = projectId ? projectId : process.env.VUE_APP_AI_CLOUD_PROJECT_ID;
      window.localStorage.setItem("ai-projectid", localProjectId);
      this.setProjectId(localProjectId);

      // Set current client user
      user.isManager = insightService.setManager(user, localProjectId, window.localStorage);
      insightService.setId(user, window.localStorage);
      this.setCurrentClient(user);

      // Fetching the ai resource container to store its path
      this.$refs.nuxeoPP.query = `SELECT * FROM Document WHERE ecm:primaryType = 'AIResourcesContainer'
        AND ecm:isTrashed = 0 AND ecm:isVersion = 0 AND airc:projectid = '${localProjectId}'`;
      this.$refs.nuxeoPP.params.queryParams = null;
      this.$refs.nuxeoPP.fetch().then(result => {
        this.setAIResourcePath(result.entries[0].path);
      }).catch(() => {
        this.setCurrentClient({});
        this.navigateToNotFound();
      });
      this.$refs.fetchDatasourceLabel.get().then((datasource) => {
        this.datasource = datasource;
      });
    },
    ...mapMutations({
      setProjectId: "setProjectId",
      setCurrentClient: "setCurrentClient",
      setUrlCore: "setUrlCore",
      setAIResourcePath: 'setAIResourcePath',
    }),
    isConnected(datasource) {
      return datasource !== 'OFF';
    },
    navigateToNotFound() {
      this.$router.push({name: 'noauth'});
    },
    navigateToUser() {
      this.$router.push({name: "user", params: {id: this.currentClient.properties.username}});
    },
    navigateToConfig() {
      this.$router.push({name: "config"});
    },
    navigateToDashboard() {
      this.$router.push({name: "dashboard"});
    },
  }
};
